import { enumFillMode, kTriAnnoW, NS_SVG } from "../constants";
import { SVG_SetDash } from "./SVG_SetDash";
import { SVG_ShiftY } from "./SVG_ShiftY";
import { SVG_ShiftX } from "./SVG_ShiftX";
import { SVG_DrawTri2 } from "./SVG_DrawTri2";

export function SVG_DrawTri(
  bounds,
  boxShape,
  borderThickness,
  triColor,
  triPosition,
  borderColor,
  dashColor,
  subTriColor,
  svgElement
) {
  var bt = borderThickness / 2;
  var width = kTriAnnoW;
  var height = kTriAnnoW;
  var posRight = triPosition == 0;

  var sx = posRight ? bounds.fRight - width - bt : bounds.fLeft + bt; // + bt + width;
  var sy = bounds.fTop + bt;

  SVG_DrawTri2(
    sx,
    sy,
    width,
    height,
    triColor,
    subTriColor,
    triPosition,
    false,
    boxShape,
    svgElement,
    enumFillMode.triangle
  );

  var x1, x2;

  x1 = posRight ? sx - 0.5 : sx + width + 0.5;
  x2 = posRight ? sx + width + 0.5 : sx - 0.5;

  var y1 = sy - 0.5;
  var y2 = sy + height + 0.5;

  var thickness = 1;
  var lineColor = borderColor;
  if (dashColor != null) {
    thickness = 2;
    lineColor = dashColor;
    x1 = posRight ? sx + 0.5 : sx + width - 0.5;
    x2 = posRight ? sx + width - 0.5 : sx + 0.5;
    y1 = sy + 0.5;
    y2 = sy + height - 0.5;
  }
  x1 = SVG_ShiftX(x1, svgElement);
  x2 = SVG_ShiftX(x2, svgElement);
  y1 = SVG_ShiftY(y1, svgElement);
  y2 = SVG_ShiftY(y2, svgElement);

  var lineObj = document.createElementNS(NS_SVG, "line");
  lineObj.setAttribute("x1", x1);
  lineObj.setAttribute("y1", y1);
  lineObj.setAttribute("x2", x2);
  lineObj.setAttribute("y2", y2);
  lineObj.setAttribute("stroke", lineColor);
  lineObj.setAttribute("stroke-width", thickness);
  //	lineObj.setAttribute("stroke-linejoin","bevel");

  if (dashColor != null) {
    SVG_SetDash(thickness, lineObj);
  }

  svgElement.appendChild(lineObj);

  /*
	if (dashColor != null)
	{
		hsx = hsx + 1;
		hex = hex - 1;
		hsy = hsy - 1;
		dashed = true;
		hypoThickness = 2;
		hypoColor = dashColor;
	}
	*/
}
